import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col p-4 justify-center items-center h-screen" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Monitor")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SlButton = _resolveComponent("SlButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.status.loading)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Loading..."))
      : _createCommentVNode("v-if", true),
    (_ctx.user.projects.length == 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "No interventions found"))
      : _createCommentVNode("v-if", true),
    (_ctx.hasMonitorRole)
      ? (_openBlock(), _createBlock(_component_SlButton, {
          key: 2,
          class: "m-4 focus:outline-none",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.monitor()))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}